import React from "react";
import styled from "styled-components";
import colors from "../constants/colors";
import constants from "../constants/constants";

const GoodyBanner = ({ goody }) => {
  return (
    <GoodyBannerComp>
      <GoodyContentWrapper>
        {goody?.goodyImage && <GoodyImage src={goody?.goodyImage?.sourceUrl} />}
        <GoodyText dangerouslySetInnerHTML={{ __html: goody?.goodyText }} />
      </GoodyContentWrapper>
    </GoodyBannerComp>
  );
};
const GoodyBannerComp = styled.div`
  width: 100%;
  padding: 8px;
  background: #ccb242;
  position: absolute;
  top: 0;
  /* height: 40px; */
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  @media (max-width: 770px) {
    position: fixed;
    top: 174px;
  }
  @media (max-width: ${constants.nexusPortraitWidth}px) {
    padding: 8px 15px;
  }
`;
const GoodyImage = styled.img`
  width: auto;
  height: 100%;
  object-fit: cover;
  max-height: 30px;
`;

const GoodyContentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  height: 100%;
  @media (max-width: 770px) {
    justify-content: space-around;
  }
  @media (max-width: ${constants.iPhonePortraitWidth}px) {
    gap: 5px;
  }
`;

const Paragraph = styled.p`
  font-family: "Montserrat";
  font-weight: 300;
  font-size: 16px;
  letter-spacing: 0.4px;
  color: #333333;
  margin-top: 0;
  text-align: left;
`;
// goodyText is an ACF WYSIWYG field, so it arrives as HTML wrapped in <p>
const RichText = styled(Paragraph).attrs({ as: "div" })`
  p {
    margin: 0;
  }
`;
const GoodyText = styled(RichText)`
  margin: auto;
  color: white;
  text-align: center;
  hyphens: auto;
  color: ${colors.SolidGreyText};
  text-decoration: underline;
  font-weight: 500;
  a {
    color: inherit;
    cursor: pointer;
  }
`;

export default GoodyBanner;
